import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './RequestVerifyPage.module.css';
import apiRequest from '../../lib/apiRequest';

const RequestVerifyPage = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleResend = async () => {
    // Check if email is empty
    if (!email.trim()) {
      setError('Please enter your email address.');
      return;
    }
    
    setLoading(true);
    setError('');
    setMessage('');
    try {
      // Call your endpoint to resend the verification email
      const res = await apiRequest.post(
        '/auth/send-verification',
        { email }
      );
      setMessage(res.data.message || 'Verification email sent. Please check your inbox.');
    } catch (err) {
      if (err.response && err.response.status === 429) {
        setError(err.response.data.message || 'Too many requests, please try again in a minute.');
      } else {
        setError(err.response?.data?.message || 'Failed to send verification email.');
      }
    } finally {
      setLoading(false);
      setEmail('');
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>Request Verification Email</h2>
      <p className={styles.info}>
        Enter your email address below to request a new verification email.
      </p>
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Your email address"
        className={styles.input}
        required
      />
      <button 
        onClick={handleResend} 
        className={styles.button} 
        disabled={loading}
      >
        {loading ? 'Sending...' : 'Send Verification Email'}
      </button>
      {message && <p className={styles.successMessage}>{message}</p>}
      {error && <p className={styles.errorMessage}>{error}</p>}
      <button 
        onClick={() => navigate('/login')}
        className={styles.backButton}
      >
        Back to Login
      </button>
    </div>
  );
};

export default RequestVerifyPage;
